// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.third_PwdGc {
    width : 33.3333%;
    height : 100%;
  }
  
  .paginationInput_S_uNv.lev-combobox.lev-combobox-paginationInput > .rw-widget-container > .rw-select.rw-select-bordered {
    width: 24px;
  }
  
  .filterCount_ni_bV {
    background-color: var( --color-brand500 );
    border-radius: 50%;
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    margin-left: 8px;
  }
  
  .content_OdMao {
    display: flex;
    align-items: center;
    overflow: visible !important;
  }
  
  
  .flex_Op8q3 {
    width: 100%;
  }
  
  /* separator */
  .paginationContainer_ZgmsK {
    width:100%;
    height: 64px;
    padding-left: 16px;
    padding-right: 16px;
  }
  
  .pageSizeText_t467S {
    padding-left: 12px;
  }
  
  .leftArrow_q2uPc {
    padding-left: 2px !important;
    margin-right: 12px;
    cursor: pointer;
  }
  
  .rightArrow_aohOY {
    padding-right: 2px !important;
    margin-left: 12px;
    cursor: pointer;
  }`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/table/TablePagination.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yCAAyC;IACzC,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,4BAA4B;EAC9B;;;EAGA;IACE,WAAW;EACb;;EAEA,cAAc;EACd;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;EACjB","sourcesContent":[".third {\n    width : 33.3333%;\n    height : 100%;\n  }\n  \n  .paginationInput:global( .lev-combobox.lev-combobox-paginationInput > .rw-widget-container > .rw-select.rw-select-bordered ) {\n    width: 24px;\n  }\n  \n  .filterCount {\n    background-color: var( --color-brand500 );\n    border-radius: 50%;\n    height: 24px;\n    width: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    margin-left: 8px;\n  }\n  \n  .content {\n    display: flex;\n    align-items: center;\n    overflow: visible !important;\n  }\n  \n  \n  .flex {\n    width: 100%;\n  }\n  \n  /* separator */\n  .paginationContainer {\n    width:100%;\n    height: 64px;\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n  \n  .pageSizeText {\n    padding-left: 12px;\n  }\n  \n  .leftArrow {\n    padding-left: 2px !important;\n    margin-right: 12px;\n    cursor: pointer;\n  }\n  \n  .rightArrow {\n    padding-right: 2px !important;\n    margin-left: 12px;\n    cursor: pointer;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"third": `third_PwdGc`,
	"paginationInput": `paginationInput_S_uNv`,
	"filterCount": `filterCount_ni_bV`,
	"content": `content_OdMao`,
	"flex": `flex_Op8q3`,
	"paginationContainer": `paginationContainer_ZgmsK`,
	"pageSizeText": `pageSizeText_t467S`,
	"leftArrow": `leftArrow_q2uPc`,
	"rightArrow": `rightArrow_aohOY`
};
export default ___CSS_LOADER_EXPORT___;
